import Vue from 'vue'
import App from './App.vue'
import VueGtag from 'vue-gtag'
import router from './router'
/* import store from './store' */
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
import Footer from './components/Footer.vue'
import Hode from './components/Header.vue'
import Meta from 'vue-meta'
// FontAwesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { faFacebook, faInstagram, faYoutube, faLinkedin, faTripadvisor, faCcVisa, faCcMastercard } from '@fortawesome/free-brands-svg-icons'
import { faMapPin, faMailBulk, faPhoneVolume } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'


library.add(   
  faFacebook, 
  faMapPin, 
  faMailBulk, 
  faPhoneVolume,
  faInstagram,
  faYoutube,
  faLinkedin,
  faTripadvisor,
  faCcVisa,
  faCcMastercard
  )


Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component("my-footer", Footer);
Vue.component("my-header", Hode);

Vue.config.productionTip = false // Skru av for production!

// Middleware
Vue.use(Buefy, { defaultIconPack: 'fas' });
Vue.use(VueGtag, {
  config: { id: "UA-5711613-1"}
})
Vue.use(Meta)

new Vue({
  router,
  /* store, */
  render: h => h(App)
}).$mount('#app')
